"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOriginalTotalElementsCount = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var AttributeFilterUtils_1 = require("../../utils/AttributeFilterUtils");
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
/**
 * Gets the number of all elements available for the attribute.
 */
exports.useOriginalTotalElementsCount = function (props) {
    var context = props.context, ownProps = props.ownProps;
    return sdk_ui_1.useCancelablePromise({
        promise: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, AttributeFilterUtils_1.getElementTotalCount(context.workspace, context.backend, AttributeFilterUtils_1.getObjRef(context.filter, context.identifier), "", // we need to get all available elements count in every case possible
                    AttributeFilterUtils_1.getValidElementsFilters(ownProps.parentFilters, ownProps.parentFilterOverAttribute))];
            });
        }); },
    }, [
        context.backend,
        context.workspace,
        context.identifier,
        json_stable_stringify_1.default(ownProps.parentFilters),
        context.filter,
    ]);
};
//# sourceMappingURL=useOriginalTotalElementsCount.js.map